import { array, number, object } from "superstruct";

const ProductStatusInRegistryResponseSchema = object({
    variantId: number(),
    variantInGiftRegistryIds: array(number()),
});

export default ProductStatusInRegistryResponseSchema;
